var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"bc-profile-empty-section",class:{'bc-profile-empty-section--self':_setup.isSelf}},[_c('em',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }